/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */
import { Box, Stack, Tab, Tabs } from "@mui/material";
import { FC, PropsWithChildren, useState } from "react";
import { JobCard } from "./JobCard";
import { JobItem } from "components/TaskRegisterMultipleCharge/hooks/GetMultipleChargeTasksHook";
import { useAwvDataContext } from "context/AwvDataProvider";

export interface AwvJobItem {
  frameTypeNumber: string;
  jobs: JobItem[];
}

interface AwvJobsDisplayProps {
  awvJobs: AwvJobItem[];
  onAwvSelected?: (frameTypeAndNumber: string) => void;
}
export const AwvJobsDisplay: FC<AwvJobsDisplayProps> = ({
  awvJobs,
  onAwvSelected,
}) => {
  const [selectedAwv, setSelectedAwv] = useState(0);
  const { awvData } = useAwvDataContext();
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        height: 324,
        // overflow: "auto",
      }}
    >
      <Tabs
        // orientation="vertical"
        variant="scrollable"
        value={selectedAwv}
        onChange={(e, v) => {
          console.log(v);
          setSelectedAwv(v);
          const frameTypeAndNumber = awvData.awvInfos?.[v].frameTypeAndNumber;
          if (frameTypeAndNumber !== undefined) {
            onAwvSelected?.(frameTypeAndNumber);
          }
        }}
        // aria-label="Vertical tabs example"
        sx={{
          borderRight: 1,
          borderColor: "divider",
          backgroundColor: "background.paper",
        }}
      >
        {awvJobs.map((awvjob) => {
          return (
            <Tab
              key={`AwvJobsDisplay-Tab-${awvjob.frameTypeNumber}`}
              label={
                awvData?.awvInfos?.find(
                  (awv) => awv.frameTypeAndNumber === awvjob.frameTypeNumber
                )?.nameId ?? "--"
              }
              // id={`vertical-tab-${awvjob.frameTypeNumber}`}
              // aria-controls={`vertical-tabpanel-${awvjob.frameTypeNumber}`}
            />
          );
        })}
      </Tabs>
      {awvJobs.map((awvjob, index) => {
        return (
          <TabPanel
            key={`AwvJobsDisplay-TabPanel-${awvjob.frameTypeNumber}`}
            index={index}
            value={selectedAwv}
          >
            <Stack gap={1}>
              {awvjob.jobs.map((job) => {
                return (
                  <JobCard
                    key={`AwvJobsDisplay-JobCard-${awvjob.frameTypeNumber}`}
                    job={job}
                  />
                );
              })}
            </Stack>
          </TabPanel>
        );
      })}
    </Box>
  );
};

interface TabPanelProps extends PropsWithChildren {
  index: number;
  value: number;
}
const TabPanel: FC<TabPanelProps> = (props: TabPanelProps) => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      // id={`vertical-tabpanel-${index}`}
      // aria-labelledby={`vertical-tab-${index}`}
      style={{
        overflow: "auto",
        padding: "5px",
        backgroundColor: "rgba(255, 255, 255, 0)",
      }}
      // {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
};
